import {TreatmentTarget} from './treatment_target'
export class WebhookTreatment extends TreatmentTarget {
  
  constructor() {
    super();
  }
  
  validate() {
    let response = {}
    this.querySelectorAll('select').forEach((input) => { 
      input.classList.remove("error")
      if(input.value === "null") {
        input.classList.add("error")
        response.requiredMissing = true 
      }
    });
    return response;
  }

  getData() {
    let webhook_id = this.querySelector("select").value;
    let action = { 
      action_id: webhook_id,
      action_timing: 1
    };
    return action;
  }

  getIcon() {
    return 'fa-cloud-upload'
  }

  isTarget() {
    return false;
  }

  static getType() {
    return "WEBHOOK"
  }

  static getEmailType() {
    return "EMAIL"
  }

  connectedCallback() {
    this.innerHTML = `
      <div class="col-sm-12 ct_action" data-action_type=WEBHOOK>
        <div class="panel panel-default" style="min-height: 100px;">
          <h4 style="margin: 10px 10px;">Integration</h4><a class="remove"><i class="fa fa-times" aria-hidden="true"></i></a>
          <div class="form-group">
            <label>Choose Integration to send</label>
            <div class="row">
              <div class="col-md-9 no-gutters">
              <select is=webhook-select class="form-control audio_id" data-selected=${this.action != null ? this.action.action_id : 'null'} 
                data-selected-name="${this.action != null && this.action.name != null ? this.action.name : 'null'}"></select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-12 ct_line">
        <div class="ct_vertical_arrow"></div>
        <div class="option_text">Integration Sent</div>
        <div class="ct_vertical_arrow">
          <div class=arrow-down></div>
        </div>
      </div>
    `;
    super.connectedCallback();
  }
}
customElements.define('webhook-treatment', WebhookTreatment); 

class WebhookSelect extends HTMLSelectElement {
  constructor() {
    super();
    this.template = document.createElement('template');
  }

  // NOT TESTED
  requestUpdate(data){
    this.data = data;

    let data_selected = this.getAttribute("data-selected");
    let data_selected_name = this.getAttribute("data-selected-name");

    if(data_selected != "null") {
      // It is possible that 
      let has_access_to_webhook = false;
      this.data.forEach(( action ) => {if(action.action_id == data_selected) has_access_to_webhook = true} );

      if(!has_access_to_webhook && data_selected_name != "null") {
        // Insert audio into options.
        this.data.unshift({action_id: data_selected, name: data_selected_name})
      }
    }

    let webhook_options = this.data.filter(action => action.action_type == "WEBHOOK").map(action => `<option value="${action.action_id}">${action.name}</option>`)
    let email_options = this.data.filter(action => action.action_type == "EMAIL").map(action => `<option value="${action.action_id}">${action.name}</option>`)
    this.template.innerHTML =`
    <option value=null>Choose</option>
    ${webhook_options.length > 0 ? `<optgroup label="Webhooks">${webhook_options.join("")}</optgroup>` : `` }
    ${email_options.length > 0 ? `<optgroup label="Emails">${email_options.join("")}</optgroup>` : `` }
    `
    let value = this.value;
    if(value == "") {
      let data_selected = this.getAttribute("data-selected");
      value = data_selected;
    }
    
    Array.from(this.options).map(opt=> {
        opt.parentNode.removeChild(opt);
    });

    this.innerHTML = "";
    this.appendChild(this.template.content.cloneNode(true));
    this.value = value;
    if(this.selectedOptions.length == 0) {
      this.value = "null"
    }
  }

  async connectedCallback() {
    let domain_id = document.querySelector("#object_id").value
    this.data_binder = new DataBinder("/admin/domains/"+domain_id+"/actions", true);
    this.data_binder.register(this);
    if(this.data_binder.data) this.requestUpdate(this.data_binder.data);
  }

  disconnectedCallback(){
    this.data_binder.unregister(this);
  }
}

customElements.define('webhook-select', WebhookSelect, {extends: 'select'});